// extracted by mini-css-extract-plugin
export default {"section":"WeekendMatchesRail_section__VG-Om","header":"WeekendMatchesRail_header__hFIAL","rail":"WeekendMatchesRail_rail__2Z6tj"};